import request from '@@/utils/request'
let serverTimeDiff = null

setInterval(() => serverTimeDiff = null, 60*1000)

/** 服务器时间 */
export async function ServerTimeApi(params) {
  if (serverTimeDiff == null) {
    const {data} = await request({
      url: '/yw/zbgg/getNowTime',
      method: 'get',
      headers: {
        isToken: false
      },
      params: params
    })
    serverTimeDiff = data - new Date().getTime()
  }
  return {
    code: 200,
    data: new Date().getTime() + serverTimeDiff
  }
}
/** 首页轮播图 */
export function lbimagesApi(data) {
  return request({
    url: '/yw/chart/list',
    method: 'get',
    headers: {
      isToken: false
    },
    data
  })
}
/**
 * 平台交易信息
 * */
export function getGgListApi(params) {
  return request({
    url: '/yw/zbgg/getGgList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
/**
 * 首页交易信息
 * */
export function getGgListNoPageApi(params) {
  return request({
    url: '/yw/zbgg/getGgListNoPage',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}


/**
 * 新闻列表
 * 新闻详情
 * @param params
 * @returns {*}
 */
export function xinwenlist(params) {
  return request({
    url: '/yw/industryInformation/list',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
export function getIndustryInformationApi(id) {
  return request({
    url: '/yw/industryInformation/' + id,
    headers: {
      isToken: false
    },
    method: 'get'
  })
}

/**
 * 工具栏
 * @param params
 * @returns {*}
 */
export function toolslist(params) {
  return request({
    url: '/yw/tools/list',
    method: 'get',
    headers: {
      isToken: false
    },
    data: params
  })
}

/** 查询常见问题分类 */
export function visibleApi(type){
  return request({
    url: `/system/publication-category/visible/${type}`,
    method: 'get'
  })
}
/** 查询常见问题 */
export function publishedListApi(type,param){
  return request({
    url: `/system/publications/published/${type}`,
    method: 'get',
    params:param
  })
}


















// 首页交易信息列表
export function getTransactionList(params) {
    return request({
      url: '/zb/zbgg/zhu/list?ggAnnouncement='+params,
      method: 'get',
      headers: {
        isToken: false
      },
      data: params
    })
  }
  // 注册 /login/register
export function uregister(params) {
  return request({
    url: '/system/login/register',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}

/** 注册代理机构 */
export function registerAgency(params) {
  return request({
    url: '/yw/registration/Agency',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}

/** 注册投标单位 */
export function registerBidder(params) {
  return request({
    url: '/yw/registration/Bidder',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}

/** 注册招标人/业主 */
export function registerTenderer(params) {
  return request({
    url: '/yw/registration/Tenderer',
    method: 'post',
    headers: {
      isToken: false
    },
    data: params
  })
}

//查询交易页面数据
export function getZbggType(data) {
  return request({
    url: '/yw/zbgg/getZbggType',
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}

export function getCollectList(params) {
  return request({
    url: '/yw/zbgg/getCollectList',
    method: 'get',
    headers: {
      isToken: false
    },
    params: params
  })
}
export function getCollectGg(data) {
  return request({
    url: `/yw/zbgg/getCollectGg`,
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}
//查询帮助中心
export function helplist(data) {
  return request({
    url: '/yw/helpcenter/list?helpType='+data,
    headers: {
      isToken: false
    },
    method: 'get',
  })
}


//查询公告详情
export function getOneGg(data) {
  return request({
    url: `/yw/zbgg/getOneGg`,
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}
//查询原公告
export function getOriginalGgApi(params) {
  return request({
    url: `/yw/zbgg/getOriginalGg`,
    method: 'get',
    headers: {
      isToken: false
    },
    params:params
  })
}
//帮助中心详情
export function getHelpcenterApi(id) {
  return request({
      url: '/yw/helpcenter/' + id,
      headers: {
        isToken: false
      },
      method: 'get'
  })
}
/**
 * 仅用于地区编码查询，仅查询省市两级
 */
export async function listTwoAll(query) {
  return request({
    url: '/system/treedict/listTwoAll',
    method: 'get',
    headers: {
      isToken: false
    },
    params: query
  })
}
/** 根据地区id查询一个配置 */
export function getByAreaIdApi(query) {
  return request({
    url: '/yw/regionManagement/getByAreaId',
    method: 'get',
    headers: {
      isToken: false
    },
    params: query
  })
}
/** 专家入库 **/
export function expertStorageApi(data) {
  return request({
    url: '/yw/userdetail/expertStorage',
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}
/** 专家入库 **/
export function storeApplyForApi(data) {
  return request({
    url: '/zb/expertManage/storeApplyFor',
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}
// 性别
export function getDict(query) {
  return request({
    url: `/system/dict/data/type1/${query}`,
    method: 'get',
    headers: {
      isToken: false
    },
  })
}

/**
 * 专区
 * 申请专区
 * @param params
 * @returns {*}
 */
export function getRegionYzApi(params) {
  return request({
    url: `/yw/tenantdetail/getRegionYz`,
    method: 'get',
    headers: {
      isToken: false
    },
    params
  })
}

export function enterpriseApi(data) {
  return request({
    url: `/yw/enterprise`,
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}

/**
 * 提交意见
 */
export function suggestionsApi(data) {
  return request({
    url: `/yw/suggestions`,
    method: 'post',
    headers: {
      isToken: false
    },
    data
  })
}
